module.exports = __webpack_public_path__ + "static/wm-b077746bc86f95e16a4a916737dc6a1e.png";